import { css, FlattenInterpolation } from 'styled-components';

import { Breakpoint, breakpoints } from '../theme';

import { pxToEm } from './units';

interface From {
  from: Breakpoint | number;
}

interface To {
  to: Breakpoint | number;
}

type BreakpointOpts = From | To | (From & To);

const hasFrom = (opts: BreakpointOpts): opts is From =>
  typeof (opts as { from?: Breakpoint }).from !== 'undefined';

const hasTo = (opts: BreakpointOpts): opts is To =>
  typeof (opts as { to?: Breakpoint }).to !== 'undefined';

export const media = (
  opts: BreakpointOpts,
  type: 'screen' | 'all' | 'print' = 'screen'
) => {
  const queries: string[] = [type];

  if (hasFrom(opts)) {
    const value =
      typeof opts.from === 'number' ? opts.from : breakpoints[opts.from];

    queries.push(`(min-width: ${pxToEm(value)})`);
  }

  if (hasTo(opts)) {
    const value = typeof opts.to === 'number' ? opts.to : breakpoints[opts.to];

    queries.push(`(max-width: ${pxToEm(value - 1)})`);
  }

  const qs = queries.join(' and ');

  return <P extends object>(
    strings: TemplateStringsArray,
    ...interpolations: FlattenInterpolation<P>
  ) => css`
    @media ${qs} {
      ${css(strings, ...interpolations)}
    }
  `;
};
